/**
 * Builds a query string from a params object, omitting keys whose value is
 * null, undefined, or an empty string so they never appear as bare `key=`
 * fragments that can corrupt backend query parsing.
 *
 * @param {Object} params - Key/value pairs to serialize.
 * @returns {string} A URL query string WITHOUT the leading `?`.
 *
 * @example
 * buildQueryParams({ page: 1, per_page: 10, name: "", parent_id: "abc" })
 * // → "page=1&per_page=10&parent_id=abc"
 *
 * @example
 * buildQueryParams({ page: 2, per_page: 10, name: "col", parent_id: "" })
 * // → "page=2&per_page=10&name=col"
 */
const buildQueryParams = (params) => {
    const urlParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
        urlParams.append(key, value);
        }
    });

    return urlParams.toString();
};

export default buildQueryParams;